/** @format */
/**
 * Any new action type should be added to the set of exports below, with the
 * value mirroring its exported name.
 *
 * Please keep this list alphabetized!
 *
 */
export const ADD_THEME = 'ADD_THEME';
export const ADD_PLUGIN = 'ADD_PLUGIN';

export const CHECK_STATUS = 'CHECK_STATUS';
export const CLOSE_PREVIEW_THEME = 'CLOSE_PREVIEW_THEME';

export const FETCH_WIZARD_DATA = 'FETCH_WIZARD_DATA';
export const FETCH_WIZARD_DATA_FAILURE = 'FETCH_WIZARD_DATA_FAILURE';
export const FETCH_WIZARD_DATA_SUCCESS = 'FETCH_WIZARD_DATA_SUCCESS';

export const FETCH_STEPS_DATA = 'FETCH_STEPS_DATA';
export const FETCH_STEPS_DATA_FAILURE = 'FETCH_STEPS_DATA_FAILURE';
export const FETCH_STEPS_DATA_SUCCESS = 'FETCH_STEPS_DATA_SUCCESS';

export const SEND_REQUEST = 'SEND_REQUEST';
export const SEND_REQUEST_SUCCESS = 'SEND_REQUEST_SUCCESS';
export const SEND_REQUEST_FAILURE = 'SEND_REQUEST_FAILURE';

export const STEP_CHANGE_NEXT = 'STEP_CHANGE_NEXT';
export const STEP_CHANGE_PREV = 'STEP_CHANGE_PREV';

export const PAGE_INIT = 'PAGE_INIT';
export const PAGE_RESIZE = 'PAGE_RESIZE';
export const PREVIEW_THEME = 'PREVIEW_THEME';

export const REMOVE_PLUGIN = 'REMOVE_PLUGIN';
export const REMOVE_ALL_PLUGINS = 'REMOVE_ALL_PLUGINS';

export const SEND_STATISTICS = 'SEND_STATISTICS';
export const ADD_THEME_TAG = 'ADD_THEME_TAG';

export const UPDATE_STATUS = 'UPDATE_STATUS';